export default {
  surface: {
    itself: 'Suprafață',
    '*': 'Suprafață *',
    required: 'Suprafața e obligatorie',
    unit: 'mp',
  },
};
